const pageInfo = {
	eBill:{
		p1:'註:申請電子帳單E-Mail若3天內未認證成功，將預設成簡訊帳單',
		p2:'提醒您當您完成認證後',
		p3:'本期您會收到實體帳單及電子帳單，下一期實體帳單將不再寄送。',
		p4:'亞太電信將於每月結帳日後5天寄發電子帳單至您指定電子帳單郵件信箱，或是您也可以隨時上網至『帳單作業』服務選項中查詢您最近四期帳單內容。',
	},
	SMS:{
		p1:'您已完成申請手續，稍後系統將會發送一則簡訊帳單服務申請完成通知簡訊，謝謝您的使用。',
		p2:'提醒您',
		p3:'本期您會收到簡訊帳單，實體帳單將不再寄送。',
		p4:'亞太電信將於每月結帳日後5天寄發簡訊帳單至您指定的服務通知簡訊代表號，或是您也可以隨時上網至『帳單作業』服務選項中查詢您最近四期帳單內容。',
	}
}
export default {
	name: 'e-bill-apply-result',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText'],
	data() {
		return {
			profile: this.$store.state.profile,
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	methods: {
		getInfo(i){
			return pageInfo[this.applyOption]['p' + i];
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillApply/eBillApplyResult.js